const api = process.env.REACT_APP_API_HOST || 'http://localhost:5000'
//const api = 'https://exploring-ai-api.herokuapp.com'
//console.log(process.env.REACT_APP_API_URL)
export const submitSearchRequest = (query) =>
  fetch(`${api}/search?q=${query}`)
    .then(res => res.json())



// WEBPACK FOOTER //
// ./src/utils/api.js